module.exports = __webpack_public_path__ + "media/images/front/icon_info-f8996be64ad83a8dda719ff2b668e34d.png";